const AMOUNT_TYPE_LABELS = {
  fixed: "Fixed",
  percentage: "Percentage",
};

const FREQUENCY_LABELS = {
  1: "Monthly",
  3: "Quarterly",
  6: "Half-Yearly",
  12: "Yearly",
};

const formatDate = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
};

// Employee/Employer Contribution render differently depending on amount_type:
// - fixed: a flat amount, no max
// - percentage: a % value, plus its max cap in parentheses
const renderContribution = (row, prefix) => {
  const contribution = row[`${prefix}_contribution`];

  if (contribution === null || contribution === undefined || contribution === "") {
    return "-";
  }

  if (row.amount_type === "percentage") {
    const max = row[`${prefix}_contribution_max`];
    const maxText = max !== null && max !== undefined && max !== "" ? ` (Max ${Number(max).toFixed(2)})` : "";
    return `${Number(contribution).toFixed(2)}%${maxText}`;
  }

  return Number(contribution).toFixed(2);
};

const getColumns = (handleEditLwfMaster, handleDelete) => [
  {
    label: "State",
    field: "state",
    className: "fw-semibold",
    sortable: true,
    render: (row) => row.state_name || row.state || "N/A",
  },
  {
    label: "Salary From",
    field: "salary_from",
    sortable: true,
    render: (row) => (row.salary_from !== null && row.salary_from !== undefined ? Number(row.salary_from).toFixed(2) : "0.00"),
  },
  {
    label: "Salary To",
    field: "salary_to",
    sortable: true,
    render: (row) => (row.salary_to !== null && row.salary_to !== undefined ? Number(row.salary_to).toFixed(2) : "0.00"),
  },
  {
    label: "Amount Type",
    field: "amount_type",
    className: "text-center",
    sortable: true,
    render: (row) => (
      <span className={`badge ${row.amount_type === "percentage" ? "bg-info" : "bg-secondary"}`}>
        {AMOUNT_TYPE_LABELS[row.amount_type] || "-"}
      </span>
    ),
  },
  {
    label: "Employee Contribution",
    field: "employee_contribution",
    sortable: false,
    render: (row) => renderContribution(row, "employee"),
  },
  {
    label: "Employer Contribution",
    field: "employer_contribution",
    sortable: false,
    render: (row) => renderContribution(row, "employer"),
  },
  {
    label: "Frequency",
    field: "frequency",
    sortable: true,
    render: (row) => FREQUENCY_LABELS[row.frequency] || "-",
  },
  {
    label: "Effective From",
    field: "effective_from",
    sortable: true,
    render: (row) => formatDate(row.effective_from),
  },
  {
    label: "Effective To",
    field: "effective_to",
    sortable: true,
    render: (row) => formatDate(row.effective_to),
  },
  {
    label: "Status",
    field: "status",
    className: "text-center",
    sortable: false,
    render: (row) => (
      <span className={`badge ${row.status ? "bg-success" : "bg-danger"}`}>{row.status ? "Active" : "Inactive"}</span>
    ),
  },
  {
    label: "Action",
    field: "action",
    className: "fw-semibold text-center",
    sortable: false,
    render: (row) => (
      <div className="d-flex gap-2 justify-content-center">
        <div className="cursor-pointer text-primary" onClick={() => handleEditLwfMaster(row)} title="Edit">
          <span className="material-icons-outlined" style={{ fontSize: "20px" }}>
            edit
          </span>
        </div>
        <div className="cursor-pointer text-danger" onClick={() => handleDelete(row.id)} title="Delete">
          <span className="material-icons-outlined" style={{ fontSize: "20px" }}>
            delete
          </span>
        </div>
      </div>
    ),
  },
];

export default getColumns;